export default "__VITE_ASSET__BaDMDhuN__"